
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cm2rU", function(module, exports) {

$parcel$export(module.exports, "default", () => $60de571a416785ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable formatjs/no-literal-string-in-jsx */ /* eslint-disable no-restricted-imports */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $c6GJD = parcelRequire("c6GJD");

var $ar661 = parcelRequire("ar661");

var $PAiZW = parcelRequire("PAiZW");

var $lfQiY = parcelRequire("lfQiY");

var $fJvXe = parcelRequire("fJvXe");
var $hRQgD = parcelRequire("hRQgD");
var $6FJLn = parcelRequire("6FJLn");

var $2YerA = parcelRequire("2YerA");

var $7XIdu = parcelRequire("7XIdu");

var $4nMma = parcelRequire("4nMma");

var $2mPpz = parcelRequire("2mPpz");
var $6Ht9d = parcelRequire("6Ht9d");

var $4jR19 = parcelRequire("4jR19");

var $9qPN0 = parcelRequire("9qPN0");

var $lFxsG = parcelRequire("lFxsG");

var $kaNhw = parcelRequire("kaNhw");

var $ePT1r = parcelRequire("ePT1r");
const $60de571a416785ce$var$adminSwitcherItemStyle = null;
const $60de571a416785ce$var$discoverMoreProductsTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
    id: "app-switcher-discovery-section.discover-more-products",
    defaultMessage: "Discover more apps"
});
const $60de571a416785ce$var$recommendedForYourTeamTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
    id: "app-switcher-discovery-section.recommended-for-your-team",
    defaultMessage: "Recommended for your team"
});
const $60de571a416785ce$var$moreAtlassianProducts = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
    id: "app-switcher-discovery-section.more-atlassian-products",
    defaultMessage: "More Atlassian apps"
});
const $60de571a416785ce$var$CROSS_FLOW_SOURCE_COMPONENT = 'atlassian-switcher';
const $60de571a416785ce$var$CROSS_FLOW_SOURCE_CONTEXT = 'more';
const $60de571a416785ce$var$PLACEMENT_ID = 'app-switcher-discovery-section'; // Jira Local Consumption - MessageRenderer is typed as 'React.FC<any>' as otherwise it fails typecheck within Jira with the below error:
const $60de571a416785ce$export$2df1250b8f917a59 = (0, $kaNhw.initializeMessageRenderer)();
const $60de571a416785ce$export$6b2f07b528cc1aa5 = (0, $ePT1r.withAppSwitcherDiscoverySectionIntlProvider)((0, $2mPpz.createPlacementComponent)($60de571a416785ce$var$PLACEMENT_ID, ({ initialData: initialData, extraAnalyticsAttributes: extraAnalyticsAttributes })=>{
    const initialDataState = (0, $6Ht9d.useInitialData)(initialData);
    const crossFlow = (0, $2YerA.useCrossFlow)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const isInWacContext = (0, $4nMma.useIsWacContext)();
    const handleClickMoreAtlassianProducts = (0, $gwFzn.useCallback)(async ()=>{
        if (crossFlow.isEnabled) {
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'discoverMoreAtlassianProductsButton'
            });
            await crossFlow.api.open({
                journey: (0, $2YerA.Journeys).DISCOVER,
                sourceComponent: $60de571a416785ce$var$CROSS_FLOW_SOURCE_COMPONENT,
                sourceContext: $60de571a416785ce$var$CROSS_FLOW_SOURCE_CONTEXT
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $gwFzn.useState)([]);
    const { dismissedMessageIds: dismissedMessageIds, showFlag: showFlag, handleDismissFlag: handleDismissFlag } = (0, $9qPN0.useProductDismissalFlag)();
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $lfQiY.useFireCrossFlowAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $PAiZW.usePostOfficeContext)();
    const handleOnDismissed = (0, $gwFzn.useCallback)((dismissedMessageInstanceId)=>{
        setDismissedMessageInstanceIds([
            ...dismissedMessageInstanceIds,
            dismissedMessageInstanceId
        ]);
        showFlag(dismissedMessageInstanceId);
    }, [
        dismissedMessageInstanceIds,
        showFlag
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (initialDataState.data?.messages) {
            const productIds = initialDataState.data.messages.map((message)=>$60de571a416785ce$var$getProductIdFromMessageTemplateId(message.messageTemplateId)).filter(Boolean);
            fireViewedUIEvent({
                action: 'viewed',
                actionSubject: 'section',
                actionSubjectId: 'atlassianSwitcherDiscoverProducts'
            }, {
                source: 'atlassianSwitcherDiscoverProductsSection',
                recommendedProductIds: productIds
            }, {
                isSiteAdmin: isSiteAdmin
            });
        }
    }, [
        fireViewedUIEvent,
        initialDataState.data?.messages,
        isSiteAdmin
    ]);
    if (initialDataState.error) return null;
    if (initialDataState.isLoading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hRQgD.default), {});
    const messages = initialDataState?.data.messages;
    const messagesWithoutDismissed = messages.filter((message)=>!dismissedMessageInstanceIds.includes(message.messageInstanceId));
    const decideTitle = ()=>{
        if (isInWacContext && messagesWithoutDismissed.length === 0) return null;
        return messagesWithoutDismissed.length > 0 ? $60de571a416785ce$var$recommendedForYourTeamTitle : $60de571a416785ce$var$discoverMoreProductsTitle;
    };
    const title = decideTitle(); // GALILEO-1402 START
    // check if there is a recommendation for JSM or JPD
    const hasJsmOrJpdRecommendation = messagesWithoutDismissed.some((message)=>message.messageTemplateId === 'recommendation-jsm' || message.messageTemplateId === 'recommendation-jpd'); // Fire exposure event ONLY if there is a recommendation for JSM or JPD
    hasJsmOrJpdRecommendation && (0, $c6GJD.default).getExperimentValue('recommend_templates_from_switcher_for_jpd_and_jsm', 'recommendation', 'product'); // GALILEO-1402 END
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fJvXe.SectionContainer), {
        sectionId: "discover",
        title: title,
        children: [
            messagesWithoutDismissed.map((message)=>/*#__PURE__*/ (0, $7UHDa.jsx)($60de571a416785ce$export$2df1250b8f917a59, {
                    ...message,
                    onDismissed: handleOnDismissed,
                    loadingFallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lFxsG.SwitcherSkeletonItem), {}),
                    extraAnalyticsAttributes: extraAnalyticsAttributes
                }, message.messageInstanceId)),
            isInWacContext ? null : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FJLn.default), {
                onClick: handleClickMoreAtlassianProducts,
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                    className: (0, $35pXk.default)([
                        "_2rkopd34 _1reo15vq _18m915vq _bfhkm7j4 _syaz131l _1e0c1txw _1bsbxy5q _4t3ixy5q _4cvr1h6o _1bah1h6o"
                    ]),
                    children: (0, $ar661.MoreAtlassianAppsIcon)({
                        label: 'Discover More',
                        size: '32',
                        testId: 'app-switcher-discover-more-section__icon'
                    })
                }),
                children: $60de571a416785ce$var$moreAtlassianProducts
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9qPN0.ProductDismissalFlag), {
                dismissedMessageIds: dismissedMessageIds,
                handleDismissFlag: handleDismissFlag
            })
        ]
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
const $60de571a416785ce$var$MESSAGE_TEMPLATE_ID_TO_PRODUCT_ID_MAP = {
    'recommendation-atlas': '7c917705-866d-4b6b-b266-0fc7633e8342',
    'recommendation-confluence': '6aab3f4e-cc71-474d-8d28-abef8b057808',
    'recommendation-jpd': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    'recommendation-jsm': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    'recommendation-jsw': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    'recommendation-jwm': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    'recommendation-loom': '7683a73e-423d-41a1-b43f-d497656f8b5d',
    'recommendation-opsgenie': 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    'recommendation-rovo': '91ae3e3f-138e-43be-98cc-48df03d13c32'
}; // This is a temporary mapping for this placement to contribute to go/crossflowfunnel
// It will be fixed in the future by updating the dashboard to read directly from PO analytics
const $60de571a416785ce$var$getProductIdFromMessageTemplateId = (messageTemplateId)=>{
    return $60de571a416785ce$var$MESSAGE_TEMPLATE_ID_TO_PRODUCT_ID_MAP[messageTemplateId];
};
var $60de571a416785ce$export$2e2bcd8739ae039 = $60de571a416785ce$export$6b2f07b528cc1aa5;

});
parcelRegister("ar661", function(module, exports) {

$parcel$export(module.exports, "MoreAtlassianAppsIcon", () => $33cdae2480d331a9$export$518f48548316ec87);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c121b580272220c77ea1ac97d4fc91c3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7JAtv = parcelRequire("7JAtv");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $33cdae2480d331a9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z"/>
</svg>
`;
function $33cdae2480d331a9$export$518f48548316ec87({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7JAtv.IconWrapper), {
        svg: $33cdae2480d331a9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4nMma", function(module, exports) {

$parcel$export(module.exports, "useIsWacContext", () => $0732a3e86f92a543$export$4e9304272964deb6);

var $PAiZW = parcelRequire("PAiZW");

var $27tbl = parcelRequire("27tbl");
const $0732a3e86f92a543$export$4e9304272964deb6 = ()=>{
    const context = (0, $PAiZW.usePostOfficeContext)();
    return context.product === (0, $27tbl.productNames).WAC;
};
const $0732a3e86f92a543$export$631ba87ff5b9e288 = (microsEnvType)=>{
    switch(microsEnvType){
        case 'dev':
            return 'https://admin.dev.atlassian.com';
        case 'staging':
            return 'https://admin.stg.atlassian.com';
        default:
            return 'https://admin.atlassian.com';
    }
};

});
parcelRegister("27tbl", function(module, exports) {

$parcel$export(module.exports, "productNames", () => $e815e8986f234c20$export$55ed4fa25efa6fad);
const $e815e8986f234c20$export$55ed4fa25efa6fad = {
    WAC: 'marketing'
};
const $e815e8986f234c20$export$40cd2d71062b3400 = 'segment_confluence_mau_not_mcu_with_user_tenure_greater_than_90_days_siteuser';
const $e815e8986f234c20$export$f9ae93b6f9702050 = 'post-office_expt_confluence-comments-nudge';

});


parcelRegister("9qPN0", function(module, exports) {

$parcel$export(module.exports, "ProductDismissalFlag", () => $75181cea81fbaddd$export$a309243da00b18dc);
$parcel$export(module.exports, "useProductDismissalFlag", () => $75181cea81fbaddd$export$887afb916153c3fb);

var $7UHDa = parcelRequire("7UHDa");

var $aD1SW = parcelRequire("aD1SW");
var $6uGcC = parcelRequire("6uGcC");

var $eCByP = parcelRequire("eCByP");

var $6fnsQ = parcelRequire("6fnsQ");

var $7XIdu = parcelRequire("7XIdu");

var $4nMma = parcelRequire("4nMma");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $jLfBr = parcelRequire("jLfBr");

var $6I9AF = parcelRequire("6I9AF");
// /**--Title--**/
const $75181cea81fbaddd$var$Title = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        id: "growth.app-switcher-discovery-section.flag.title",
        defaultMessage: "Got it, thanks for letting us know"
    });
// /**--Description--**/
const $75181cea81fbaddd$var$Description = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        id: "growth.app-switcher-discovery-section.flag.description",
        defaultMessage: "You won\u2019t see this here as often."
    });
const $75181cea81fbaddd$export$a309243da00b18dc = ({ dismissedMessageIds: dismissedMessageIds, handleDismissFlag: handleDismissFlag })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const isInWacContext = (0, $4nMma.useIsWacContext)();
    const onDismissed = (messageId)=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsFlagClose'
        });
        handleDismissFlag(messageId);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
        children: dismissedMessageIds.map((messageId)=>isInWacContext ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jLfBr.WacToast), {
                title: /*#__PURE__*/ (0, $7UHDa.jsx)($75181cea81fbaddd$var$Title, {}),
                description: /*#__PURE__*/ (0, $7UHDa.jsx)($75181cea81fbaddd$var$Description, {}),
                onDismissed: ()=>onDismissed(messageId)
            }, messageId) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aD1SW.default), {
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eCByP))), {
                    primaryColor: `var(--ds-icon-success, ${$6fnsQ.G400})`,
                    label: "Success"
                }),
                description: /*#__PURE__*/ (0, $7UHDa.jsx)($75181cea81fbaddd$var$Description, {}),
                id: messageId,
                title: /*#__PURE__*/ (0, $7UHDa.jsx)($75181cea81fbaddd$var$Title, {}),
                appearance: 'normal',
                onDismissed: ()=>onDismissed(messageId)
            }, messageId))
    });
};
const $75181cea81fbaddd$export$887afb916153c3fb = ()=>{
    const [dismissedMessageIds, setDismissedMessageIds] = (0, $gwFzn.useState)([]);
    return {
        dismissedMessageIds: dismissedMessageIds,
        showFlag: (dismissedMessageId)=>setDismissedMessageIds((current)=>[
                    ...current,
                    dismissedMessageId
                ]),
        handleDismissFlag: (dismissedMessageId)=>setDismissedMessageIds((0, $6I9AF.removeMessage)(dismissedMessageId))
    };
};

});
parcelRegister("jLfBr", function(module, exports) {

$parcel$export(module.exports, "WacToast", () => $990856b2b017a9e4$export$df43802f8a343160);
/* wac-toast.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ge0Ua = parcelRequire("ge0Ua");

var $dBxQj = parcelRequire("dBxQj");
const $990856b2b017a9e4$var$mainContainerStyle = null;
const $990856b2b017a9e4$var$closedToastStyle = null;
const $990856b2b017a9e4$var$contentSectionStyle = null;
const $990856b2b017a9e4$var$imageSectionStyle = null;
const $990856b2b017a9e4$var$showToastAnimationStyle = null;
const $990856b2b017a9e4$var$titleStyle = null;
const $990856b2b017a9e4$var$descriptionStyle = null;
const $990856b2b017a9e4$var$closePanelIconContainerStyle = null;
const $990856b2b017a9e4$export$df43802f8a343160 = (props)=>{
    const { title: title, description: description, onDismissed: onDismissed } = props;
    const [shouldAnimate, setShouldAnimate] = (0, $gwFzn.useState)(false);
    const [isClosed, setIsClosed] = (0, $gwFzn.useState)(false);
    const intl = (0, $dBxQj.default)();
    const dismissToastAriaLabel = intl.formatMessage({
        id: "growth.app-switcher-discovery-section.wac-toast.close.aria-label",
        defaultMessage: "Dismiss toast"
    });
    (0, $gwFzn.useEffect)(()=>{
        setTimeout(()=>{
            setShouldAnimate(true);
        }, 100);
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        // auto dismiss
        setTimeout(()=>{
            closeToastCard();
        }, 8000);
    }, []);
    const closeToastCard = ()=>{
        setIsClosed(true);
    };
    const handleOnCloseClick = ()=>{
        closeToastCard();
        setTimeout(()=>{
            onDismissed && onDismissed();
        }, 800);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_2rko1b66 _tzy4idpf _16qs1nta _1bsb1178 _bfhkvuon _t9ec1pmk _1qza1osq _1mrf17un",
            shouldAnimate && "_v56413jc _tzy4kb7n _t9ec1kli _1mrfvg6r",
            isClosed && "_v564wlka _tzy4idpf _t9ec1o0r _1qza1osq _1mrf1jum"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            className: (0, $35pXk.default)([
                "_2rko1b66 _1yt41ejb _1e0c1txw _2lx21bp4 _bfhkvuon _y3gn1e5h"
            ]),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                    className: (0, $35pXk.default)([
                        "_1e0c1txw _2lx2vrvc _1bah1yb4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)($990856b2b017a9e4$var$SuccessIcon, {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("button", {
                            id: "toast-close-button",
                            onClick: handleOnCloseClick,
                            "aria-label": dismissToastAriaLabel,
                            className: (0, $35pXk.default)([
                                "_bfhk18uv _19itidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ge0Ua))), {
                                label: dismissToastAriaLabel,
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("h3", {
                    className: (0, $35pXk.default)([
                        "_k48p1nn1 _vwz43ei5 _ect41kw7 _1wyb1k8s _19pkpxbi _otyru2gc"
                    ]),
                    children: title
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("p", {
                    className: (0, $35pXk.default)([
                        "_18s81bpf"
                    ]),
                    children: description
                })
            ]
        })
    });
};
const $990856b2b017a9e4$var$SuccessIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM27.8668 16.2282C28.4316 15.6086 28.4144 14.648 27.8154 14.049L27.7617 13.9977C27.142 13.4329 26.1815 13.45 25.5825 14.049L17.2709 22.3606L14.4176 19.5074L14.3639 19.4561C13.7442 18.8913 12.7837 18.9084 12.1847 19.5074C11.568 20.124 11.568 21.1237 12.1847 21.7404L16.1544 25.7101L16.2082 25.7614C16.8278 26.3262 17.7883 26.3091 18.3873 25.7101L27.8154 16.282L27.8668 16.2282Z",
            fill: "#82B536"
        })
    });

});

parcelRegister("6I9AF", function(module, exports) {

$parcel$export(module.exports, "removeMessage", () => $8d3e387dfec25223$export$f9a3c275d8ffdac0);
const $8d3e387dfec25223$export$f9a3c275d8ffdac0 = (messageId)=>(currentMessageIds)=>currentMessageIds.filter((id)=>id !== messageId);

});


parcelRegister("lFxsG", function(module, exports) {

$parcel$export(module.exports, "SwitcherSkeletonItem", () => $2e1ba8ce904738f1$export$d281ba7ce1dcaa47);
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $lYygP = parcelRequire("lYygP");
const $2e1ba8ce904738f1$var$iconSkeletonStyles = null;
const $2e1ba8ce904738f1$var$lineSkeletonStyles = null;
const $2e1ba8ce904738f1$var$iconSkeleton = /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
    className: (0, $35pXk.default)([
        "_2rkopd34 _1e0c1o8l _1bsbzwfg _4t3izwfg _bfhkn82g"
    ])
});
const $2e1ba8ce904738f1$var$lineSkeleton = /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
    className: (0, $35pXk.default)([
        "_2rko1sit _1e0c1o8l _1bsb1uc6 _4t3i19bv _bfhkn82g"
    ])
}); // TODO: Export this as a primitive from Switcher instead of creating it here
const $2e1ba8ce904738f1$export$d281ba7ce1dcaa47 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lYygP.default), {
        tag: "li",
        icon: $2e1ba8ce904738f1$var$iconSkeleton,
        isDisabled: true,
        children: $2e1ba8ce904738f1$var$lineSkeleton
    });
};

});

parcelRegister("kaNhw", function(module, exports) {

$parcel$export(module.exports, "initializeMessageRenderer", () => $1747fe69d2df31f5$export$bce4e5106d86e473);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $cyz5M = parcelRequire("cyz5M");

var $beAnL = parcelRequire("beAnL");

var $fVDar = parcelRequire("fVDar");

var $lTT56 = parcelRequire("lTT56");

var $cOelw = parcelRequire("cOelw");
const $1747fe69d2df31f5$export$e30378e28ad3e6ab = {
    ...(0, $beAnL.default),
    ...(0, $fVDar.default),
    ...(0, $lTT56.default),
    ...(0, $cOelw.default)
};
const { initializeMessageRenderer: $1747fe69d2df31f5$export$bce4e5106d86e473, MessageRenderer: $1747fe69d2df31f5$export$2df1250b8f917a59 } = (0, $cyz5M.asMessageRenderer)($1747fe69d2df31f5$export$e30378e28ad3e6ab);

});
parcelRegister("beAnL", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c16971a334a19d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");









var $05c16971a334a19d$export$2e2bcd8739ae039 = {
    'recommendation-atlas': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cON0J"))),
    'recommendation-confluence': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jKRDx"))),
    'recommendation-jpd': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5Yzjv"))),
    'recommendation-jsm': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("17xNr"))),
    'recommendation-jsw': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bNrXY"))),
    'recommendation-jsw-dynamic-description': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bILyc"))),
    'recommendation-jwm': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gbHid"))),
    'recommendation-loom': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("71pqd"))),
    'recommendation-opsgenie': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gfY07")))
};

});
parcelRegister("cON0J", function(module, exports) {

let $95502c168c98206d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $95502c168c98206d$var$load("8tqgK"),
    $95502c168c98206d$var$load("02UZz"),
    $95502c168c98206d$var$load("aGZFn"),
    $95502c168c98206d$var$load("8gQKz"),
    $95502c168c98206d$var$load("ctZCD"),
    $95502c168c98206d$var$load("8DoxJ"),
    $95502c168c98206d$var$load("joJy8"),
    $95502c168c98206d$var$load("aHE9G"),
    $95502c168c98206d$var$load("6m2wP")
]).then(()=>parcelRequire('h3wNo'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("jKRDx", function(module, exports) {

let $e61beb5485cf51df$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e61beb5485cf51df$var$load("8tqgK"),
    $e61beb5485cf51df$var$load("02UZz"),
    $e61beb5485cf51df$var$load("8gQKz"),
    $e61beb5485cf51df$var$load("ctZCD"),
    $e61beb5485cf51df$var$load("8DoxJ"),
    $e61beb5485cf51df$var$load("joJy8"),
    $e61beb5485cf51df$var$load("aHE9G"),
    $e61beb5485cf51df$var$load("gopxm")
]).then(()=>parcelRequire('1BKEb'));

});

parcelRegister("5Yzjv", function(module, exports) {

let $459df2e31cf1306c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $459df2e31cf1306c$var$load("8tqgK"),
    $459df2e31cf1306c$var$load("02UZz"),
    $459df2e31cf1306c$var$load("f0Rp7"),
    $459df2e31cf1306c$var$load("8gQKz"),
    $459df2e31cf1306c$var$load("ctZCD"),
    $459df2e31cf1306c$var$load("ffEVr"),
    $459df2e31cf1306c$var$load("kjZZD"),
    $459df2e31cf1306c$var$load("8DoxJ"),
    $459df2e31cf1306c$var$load("joJy8"),
    $459df2e31cf1306c$var$load("aHE9G"),
    $459df2e31cf1306c$var$load("9N316")
]).then(()=>parcelRequire('4cOCK'));

});

parcelRegister("17xNr", function(module, exports) {

let $0d10a9230b30c0ff$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0d10a9230b30c0ff$var$load("8tqgK"),
    $0d10a9230b30c0ff$var$load("02UZz"),
    $0d10a9230b30c0ff$var$load("f0Rp7"),
    $0d10a9230b30c0ff$var$load("8gQKz"),
    $0d10a9230b30c0ff$var$load("ctZCD"),
    $0d10a9230b30c0ff$var$load("ffEVr"),
    $0d10a9230b30c0ff$var$load("kjZZD"),
    $0d10a9230b30c0ff$var$load("8DoxJ"),
    $0d10a9230b30c0ff$var$load("joJy8"),
    $0d10a9230b30c0ff$var$load("aHE9G"),
    $0d10a9230b30c0ff$var$load("603iI")
]).then(()=>parcelRequire('jGNAq'));

});

parcelRegister("bNrXY", function(module, exports) {

let $8969f6da614f3c31$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8969f6da614f3c31$var$load("8tqgK"),
    $8969f6da614f3c31$var$load("02UZz"),
    $8969f6da614f3c31$var$load("8gQKz"),
    $8969f6da614f3c31$var$load("ctZCD"),
    $8969f6da614f3c31$var$load("ffEVr"),
    $8969f6da614f3c31$var$load("kjZZD"),
    $8969f6da614f3c31$var$load("8DoxJ"),
    $8969f6da614f3c31$var$load("joJy8"),
    $8969f6da614f3c31$var$load("aHE9G"),
    $8969f6da614f3c31$var$load("dVwBo")
]).then(()=>parcelRequire('hLkI7'));

});

parcelRegister("bILyc", function(module, exports) {

let $8888b059b659747d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8888b059b659747d$var$load("8tqgK"),
    $8888b059b659747d$var$load("02UZz"),
    $8888b059b659747d$var$load("8gQKz"),
    $8888b059b659747d$var$load("ctZCD"),
    $8888b059b659747d$var$load("ffEVr"),
    $8888b059b659747d$var$load("kjZZD"),
    $8888b059b659747d$var$load("8DoxJ"),
    $8888b059b659747d$var$load("joJy8"),
    $8888b059b659747d$var$load("aHE9G"),
    $8888b059b659747d$var$load("ipxYo")
]).then(()=>parcelRequire('6h9cg'));

});

parcelRegister("gbHid", function(module, exports) {

let $bc8f417a1e55f672$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bc8f417a1e55f672$var$load("8tqgK"),
    $bc8f417a1e55f672$var$load("02UZz"),
    $bc8f417a1e55f672$var$load("8gQKz"),
    $bc8f417a1e55f672$var$load("ctZCD"),
    $bc8f417a1e55f672$var$load("ffEVr"),
    $bc8f417a1e55f672$var$load("kjZZD"),
    $bc8f417a1e55f672$var$load("8DoxJ"),
    $bc8f417a1e55f672$var$load("joJy8"),
    $bc8f417a1e55f672$var$load("aHE9G"),
    $bc8f417a1e55f672$var$load("l37ax")
]).then(()=>parcelRequire('7Z4Bp'));

});

parcelRegister("71pqd", function(module, exports) {

let $51cc58a2749076b1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $51cc58a2749076b1$var$load("8tqgK"),
    $51cc58a2749076b1$var$load("02UZz"),
    $51cc58a2749076b1$var$load("8gQKz"),
    $51cc58a2749076b1$var$load("ctZCD"),
    $51cc58a2749076b1$var$load("ffEVr"),
    $51cc58a2749076b1$var$load("kjZZD"),
    $51cc58a2749076b1$var$load("8DoxJ"),
    $51cc58a2749076b1$var$load("joJy8"),
    $51cc58a2749076b1$var$load("aHE9G"),
    $51cc58a2749076b1$var$load("ntv3W")
]).then(()=>parcelRequire('itIol'));

});

parcelRegister("gfY07", function(module, exports) {

let $bd5c9700659f2cbc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bd5c9700659f2cbc$var$load("8tqgK"),
    $bd5c9700659f2cbc$var$load("02UZz"),
    $bd5c9700659f2cbc$var$load("8gQKz"),
    $bd5c9700659f2cbc$var$load("ctZCD"),
    $bd5c9700659f2cbc$var$load("ffEVr"),
    $bd5c9700659f2cbc$var$load("kjZZD"),
    $bd5c9700659f2cbc$var$load("8DoxJ"),
    $bd5c9700659f2cbc$var$load("joJy8"),
    $bd5c9700659f2cbc$var$load("aHE9G"),
    $bd5c9700659f2cbc$var$load("1b5ye")
]).then(()=>parcelRequire('mhFvJ'));

});


parcelRegister("fVDar", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d3eaf535df8ab6d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $2d3eaf535df8ab6d$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hE9yq")))
};

});
parcelRegister("hE9yq", function(module, exports) {

let $cd8d95595feae168$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cd8d95595feae168$var$load("8tqgK"),
    $cd8d95595feae168$var$load("ctZCD"),
    $cd8d95595feae168$var$load("eEBx4")
]).then(()=>parcelRequire('cuPHJ'));

});


parcelRegister("lTT56", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c81a61d7d05374f$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");



var $9c81a61d7d05374f$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("j2y7l"))),
    'test-message-inapp-engagement': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hRRdX"))),
    'test-message-marketing': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5rpc8")))
};

});
parcelRegister("j2y7l", function(module, exports) {

let $ddc8ab3b7b3f4bf5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ddc8ab3b7b3f4bf5$var$load("8tqgK"),
    $ddc8ab3b7b3f4bf5$var$load("ctZCD"),
    $ddc8ab3b7b3f4bf5$var$load("f7nCb")
]).then(()=>parcelRequire('4xvKn'));

});

parcelRegister("hRRdX", function(module, exports) {

let $d020ac1fed362239$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d020ac1fed362239$var$load("8tqgK"),
    $d020ac1fed362239$var$load("ctZCD"),
    $d020ac1fed362239$var$load("9xrtp")
]).then(()=>parcelRequire('7NlMU'));

});

parcelRegister("5rpc8", function(module, exports) {

let $3f6304864e5a41ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3f6304864e5a41ea$var$load("iFcso").then(()=>parcelRequire('9NHjX'));

});


parcelRegister("cOelw", function(module, exports) {

$parcel$export(module.exports, "default", () => $59486e023b77d45f$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $59486e023b77d45f$export$2e2bcd8739ae039 = {
    'recommendation-jsw-jtbd': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2aTH3")))
};

});
parcelRegister("2aTH3", function(module, exports) {

let $1957b77b537655b4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1957b77b537655b4$var$load("8tqgK"),
    $1957b77b537655b4$var$load("02UZz"),
    $1957b77b537655b4$var$load("8gQKz"),
    $1957b77b537655b4$var$load("ctZCD"),
    $1957b77b537655b4$var$load("ffEVr"),
    $1957b77b537655b4$var$load("kjZZD"),
    $1957b77b537655b4$var$load("8DoxJ"),
    $1957b77b537655b4$var$load("joJy8"),
    $1957b77b537655b4$var$load("aHE9G"),
    $1957b77b537655b4$var$load("6gEtt")
]).then(()=>parcelRequire('7HoFq'));

});



parcelRegister("ePT1r", function(module, exports) {

$parcel$export(module.exports, "withAppSwitcherDiscoverySectionIntlProvider", () => $a62d024fdde04888$export$b73a0b4f9b1b8821);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $jQRRW = parcelRequire("jQRRW");

var $8SCD0 = parcelRequire("8SCD0");

var $3nDO6 = parcelRequire("3nDO6");

var $kdvUL = parcelRequire("kdvUL");

var $dDQ6d = parcelRequire("dDQ6d");
const $a62d024fdde04888$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $8SCD0.messagesLoader)(locale),
        (0, $3nDO6.messagesLoader)(locale),
        (0, $kdvUL.messagesLoader)(locale),
        (0, $dDQ6d.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $a62d024fdde04888$export$b73a0b4f9b1b8821 = (Component)=>{
    return (0, $jQRRW.withIntlProvider)({
        messagesLoader: $a62d024fdde04888$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("dDQ6d", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $cae2500566e87d72$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5opuK = parcelRequire("5opuK");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cae2500566e87d72$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $cae2500566e87d72$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("3GwQ2")));
        case 'da':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("3IwHT")));
        case 'de':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("6hqf5")));
        case 'en-GB':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("lpboR")));
        case 'en-US':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("aeTXi")));
        case 'en-XA':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("cnbsD")));
        case 'en-XB':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("lLbTn")));
        case 'en-ZZ':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("8h9HB")));
        case 'en':
            return $cae2500566e87d72$var$importHelper(await Promise.resolve((parcelRequire("5opuK"))));
        case 'es':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("c6oiS")));
        case 'et':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("5XCUk")));
        case 'fi':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("1sVbz")));
        case 'fr':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("42OP3")));
        case 'hu':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jzR8j")));
        case 'it':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("g7f9v")));
        case 'ja':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("cVW7q")));
        case 'ko':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("hhRyt")));
        case 'nb':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("lCjUi")));
        case 'nl':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("gL82Z")));
        case 'pl':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jH9Rb")));
        case 'pt-BR':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("6WD2N")));
        case 'ro':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("3MaVp")));
        case 'ru':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("5byCF")));
        case 'sv':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("1HsON")));
        case 'th':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("fBjos")));
        case 'tr':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jFRIs")));
        case 'uk':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jNTMO")));
        case 'vi':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("1w270")));
        case 'zh-CN':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("4bKgg")));
        case 'zh-TW':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jqQ4G")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5opuK));
    }
};

});
parcelRegister("5opuK", function(module, exports) {
module.exports = JSON.parse('{"trailblazers.recommendation-jsw-jtbd.generic.description":[{"type":0,"value":"Track work from start to finish"}],"trailblazers.recommendation-jsw-jtbd.generic.jtbd":[{"type":0,"value":"Project board"}],"trailblazers.recommendation-jsw-jtbd.lozenge.try":[{"type":0,"value":"Try"}],"trailblazers.recommendation-jsw-jtbd.marketing.description":[{"type":0,"value":"Easily plan and prioritize work"}],"trailblazers.recommendation-jsw-jtbd.marketing.jtbd":[{"type":0,"value":"Marketing project"}],"trailblazers.recommendation-jsw-jtbd.operations.description":[{"type":0,"value":"Visualize, plan, and finish work"}],"trailblazers.recommendation-jsw-jtbd.operations.jtbd":[{"type":0,"value":"Operations project"}],"trailblazers.recommendation-jsw-jtbd.pm.description":[{"type":0,"value":"See work in to-do, doing, done"}],"trailblazers.recommendation-jsw-jtbd.pm.jtbd":[{"type":0,"value":"Plan and track work"}],"trailblazers.recommendation-jsw-jtbd.swe.description":[{"type":0,"value":"Track work from start to finish"}],"trailblazers.recommendation-jsw-jtbd.swe.jtbd":[{"type":0,"value":"Project tracker"}],"trailblazers.xflow-notification-end-user-added-jira.message-template.email.subject":[{"type":0,"value":"\uD83C\uDF89 "},{"type":1,"value":"name"},{"type":0,"value":" has started using Jira"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.admin-url.no-translate":[{"type":0,"value":"admin.atlassian.com"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.headline":[{"type":1,"value":"name"},{"type":0,"value":" has started using Jira!"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.lead-paragraph":[{"type":0,"value":"Jira has been added to "},{"type":1,"value":"instanceUrl"},{"type":0,"value":". You don\u2019t need to do anything. "},{"children":[{"type":0,"value":"Jira is free for up to 10 users."}],"type":8,"value":"b"},{"type":0,"value":" You can cancel any time at "}],"trailblazers.xflow-notification-end-user-added-jira.message.email.sent-by-atlassian":[{"type":0,"value":"This message has been sent to you by Atlassian Cloud"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.take-tour.button":[{"type":0,"value":"Take a tour"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.achievable-tasks":[{"type":0,"value":"\uD83D\uDE80 Jira is a tool designed to break down any idea into achievable tasks."}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.connect-realtime":[{"type":0,"value":"\u2194\uFE0F Connect real-time data from Jira to any document in Confluence, no more copy paste."}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.visualise":[{"type":0,"value":"\uD83D\uDC40 Visualize your projects in lists, boards, backlogs, and more."}]}');

});

parcelRegister("3GwQ2", function(module, exports) {

let $2aeec45ee59a2728$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2aeec45ee59a2728$var$load("br5B5").then(()=>parcelRequire('g1ao0'));

});

parcelRegister("3IwHT", function(module, exports) {

let $2b4eda0e1f292e91$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2b4eda0e1f292e91$var$load("gjHAC").then(()=>parcelRequire('btnnE'));

});

parcelRegister("6hqf5", function(module, exports) {

let $4928afcad4972962$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4928afcad4972962$var$load("50jL1").then(()=>parcelRequire('bGslt'));

});

parcelRegister("lpboR", function(module, exports) {

let $f954c690c84bbd08$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f954c690c84bbd08$var$load("icT1H").then(()=>parcelRequire('1a85K'));

});

parcelRegister("aeTXi", function(module, exports) {

let $77469dc2c2fc427c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $77469dc2c2fc427c$var$load("jHACf").then(()=>parcelRequire('blZ2O'));

});

parcelRegister("cnbsD", function(module, exports) {

let $902085ed4bef4bd1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $902085ed4bef4bd1$var$load("gxykq").then(()=>parcelRequire('aLFng'));

});

parcelRegister("lLbTn", function(module, exports) {

let $fd7736515b60a673$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd7736515b60a673$var$load("jwi3q").then(()=>parcelRequire('kLNrh'));

});

parcelRegister("8h9HB", function(module, exports) {

let $60676fefbd95d8f6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $60676fefbd95d8f6$var$load("4vq5I").then(()=>parcelRequire('8KTi9'));

});

parcelRegister("c6oiS", function(module, exports) {

let $8cf8e5bf6d204896$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8cf8e5bf6d204896$var$load("3IaOg").then(()=>parcelRequire('1Lf8R'));

});

parcelRegister("5XCUk", function(module, exports) {

let $4570a4a84c58f57e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4570a4a84c58f57e$var$load("c1t91").then(()=>parcelRequire('5X1X6'));

});

parcelRegister("1sVbz", function(module, exports) {

let $1114c3d3ce040e71$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1114c3d3ce040e71$var$load("5x1Zd").then(()=>parcelRequire('eA4kS'));

});

parcelRegister("42OP3", function(module, exports) {

let $2f1ec59a18976fbf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2f1ec59a18976fbf$var$load("eNry3").then(()=>parcelRequire('l5c5e'));

});

parcelRegister("jzR8j", function(module, exports) {

let $e40a80508499d20d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e40a80508499d20d$var$load("qOVvt").then(()=>parcelRequire('lKBwT'));

});

parcelRegister("g7f9v", function(module, exports) {

let $bbb90db43b474427$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bbb90db43b474427$var$load("cLRtU").then(()=>parcelRequire('CZrZ8'));

});

parcelRegister("cVW7q", function(module, exports) {

let $96a7e414355b7f08$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $96a7e414355b7f08$var$load("fWDs2").then(()=>parcelRequire('86TZ1'));

});

parcelRegister("hhRyt", function(module, exports) {

let $c95d91196c453dac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c95d91196c453dac$var$load("isQud").then(()=>parcelRequire('6aeYa'));

});

parcelRegister("lCjUi", function(module, exports) {

let $fbcc96b653635be8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fbcc96b653635be8$var$load("iX3CG").then(()=>parcelRequire('f34NH'));

});

parcelRegister("gL82Z", function(module, exports) {

let $c3374727dc4edef4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3374727dc4edef4$var$load("5GFyb").then(()=>parcelRequire('jiVgR'));

});

parcelRegister("jH9Rb", function(module, exports) {

let $e569add61732189e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e569add61732189e$var$load("fDZox").then(()=>parcelRequire('5zdhe'));

});

parcelRegister("6WD2N", function(module, exports) {

let $50e6723422ce5ed2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $50e6723422ce5ed2$var$load("gYq2J").then(()=>parcelRequire('gxD3N'));

});

parcelRegister("3MaVp", function(module, exports) {

let $2bfe543f00b3aa12$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2bfe543f00b3aa12$var$load("4MDcN").then(()=>parcelRequire('8A4Kb'));

});

parcelRegister("5byCF", function(module, exports) {

let $3c68d62658a6aa3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c68d62658a6aa3b$var$load("djU0u").then(()=>parcelRequire('3qkos'));

});

parcelRegister("1HsON", function(module, exports) {

let $13d02953f2f14596$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $13d02953f2f14596$var$load("gSB6X").then(()=>parcelRequire('fMlpz'));

});

parcelRegister("fBjos", function(module, exports) {

let $b5b95adfdb94a6e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b5b95adfdb94a6e9$var$load("9s4Da").then(()=>parcelRequire('8LZxx'));

});

parcelRegister("jFRIs", function(module, exports) {

let $e52b838c595e4f8b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e52b838c595e4f8b$var$load("f73pl").then(()=>parcelRequire('iZMLO'));

});

parcelRegister("jNTMO", function(module, exports) {

let $e6adddef2b4d5886$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6adddef2b4d5886$var$load("jmWj5").then(()=>parcelRequire('bFdEh'));

});

parcelRegister("1w270", function(module, exports) {

let $11aa6b04eea485a0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $11aa6b04eea485a0$var$load("inGUf").then(()=>parcelRequire('6PHXJ'));

});

parcelRegister("4bKgg", function(module, exports) {

let $30cc130971b667be$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $30cc130971b667be$var$load("9rQBn").then(()=>parcelRequire('br3Yo'));

});

parcelRegister("jqQ4G", function(module, exports) {

let $e258d6ee187d7316$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e258d6ee187d7316$var$load("4DECc").then(()=>parcelRequire('5xVqA'));

});




parcelRegister("hNJxa", function(module, exports) {

$parcel$export(module.exports, "fetchProductRecommendationsWithCollaborators", () => $0d4b4afaa84d28bb$export$30ea0038b891f1cf);

var $jLIWc = parcelRequire("jLIWc");

var $jIyl9 = parcelRequire("jIyl9");

var $dcO0p = parcelRequire("dcO0p");
/* Joinable Sites API was replaced by Product Recommendations API as part of productionizing the Joinable Sites
   experimental API. This code maps Product Recommendations API results into Joinable Sites API results for
   compatibility with existing UI elements.
 */ function $0d4b4afaa84d28bb$var$productRecommendationsUrl(baseUrl) {
    return baseUrl + '/v1/product-recommendations' + '?product=jira-software&product=jira-servicedesk&product=confluence&product=jira-product-discovery';
}
/*
	Experiment API endpoint used to get collaborators to provided products
	https://bitbucket.org/atlassian/experiment-api/src/master/src/experiments/cross-join-switcher/
*/ const $0d4b4afaa84d28bb$var$collaboratorsUrl = '/gateway/api/growth/cross-join-switcher/get-eligible-collaborators';
// tenantedProducts and nonTenantedProducts used to identify which ARIs contain cloudId
// Also used to convert resourceOwner strings to JoinableSites product strings
const $0d4b4afaa84d28bb$var$supportedTenantedProducts = {
    confluence: (0, $dcO0p.ProductKey).CONFLUENCE,
    'jira-software': (0, $dcO0p.ProductKey).JIRA_SOFTWARE,
    'jira-product-discovery': (0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY,
    'jira-servicedesk': (0, $dcO0p.ProductKey).JIRA_SERVICE_DESK
};
const $0d4b4afaa84d28bb$var$tenantedProductsToProduct = {
    [(0, $dcO0p.ProductKey).CONFLUENCE]: 'confluence',
    [(0, $dcO0p.ProductKey).JIRA_SOFTWARE]: 'jira-software',
    [(0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY]: (0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY,
    [(0, $dcO0p.ProductKey).JIRA_SERVICE_DESK]: 'jira-servicedesk'
};
function $0d4b4afaa84d28bb$var$handleCapabilities(capabilities) {
    return capabilities?.filter((inputResource)=>{
        const parsedAri = (0, $jLIWc.AnyAri).parse(inputResource.resourceId);
        return $0d4b4afaa84d28bb$var$supportedTenantedProducts[parsedAri.resourceOwner] && parsedAri.resourceType === 'site';
    }).reduce((sites, inputValue, index)=>{
        const ari = (0, $jLIWc.AnyAri).parse(inputValue.resourceId);
        const sitesProducts = sites[ari.resourceId]?.products;
        if (sitesProducts) {
            sitesProducts[$0d4b4afaa84d28bb$var$supportedTenantedProducts[ari.resourceOwner]] = {
                collaborators: [],
                productUrl: inputValue.url,
                capability: inputValue.capability
            };
            return sites;
        }
        try {
            // Add site with this product
            const url = new URL(inputValue.url);
            const products = {};
            products[$0d4b4afaa84d28bb$var$supportedTenantedProducts[ari.resourceOwner]] = {
                collaborators: [],
                productUrl: inputValue.url,
                capability: inputValue.capability
            };
            sites[ari.resourceId] = {
                cloudId: ari.resourceId,
                url: url.origin,
                displayName: inputValue.displayName,
                products: products,
                relevance: Math.max(1000 - index, 0)
            };
            return sites;
        } catch (e) {
            return sites;
        }
    }, {});
}
function $0d4b4afaa84d28bb$var$convertProductRecommendationsResponseToJoinableSitesResponse(input) {
    const joinedCapabilities = $0d4b4afaa84d28bb$var$handleCapabilities(input.capability?.DIRECT_ACCESS.map((site)=>({
            ...site,
            capability: 'DIRECT_ACCESS'
        })).concat(input.capability?.REQUEST_ACCESS.map((site)=>({
            ...site,
            capability: 'REQUEST_ACCESS'
        }))));
    return {
        sites: Object.values(joinedCapabilities)
    };
}
function $0d4b4afaa84d28bb$var$isPublicEmailDomainError(body) {
    // Public Email Domain Error returns a body with the following content:
    // {"code":"email-public-domain","message":"Request requires a domain which is not public"}
    return body?.code === 'email-public-domain';
}
const $0d4b4afaa84d28bb$var$emptyProductRecommendationResponse = {
    capability: {
        DIRECT_ACCESS: [],
        REQUEST_ACCESS: []
    }
};
const $0d4b4afaa84d28bb$export$194985100c06d296 = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then(async (response)=>{
        const jsonPromise = response.json();
        if (response.ok) return jsonPromise;
        if (response.status === 400) {
            const json = await jsonPromise;
            if ($0d4b4afaa84d28bb$var$isPublicEmailDomainError(json)) return $0d4b4afaa84d28bb$var$emptyProductRecommendationResponse;
        }
        throw new (0, $jIyl9.FetchError)(`Unable to fetch ${url} ${response.status} ${response.statusText}`, response.status);
    }).catch(()=>{
        throw new (0, $jIyl9.FetchError)('Network Error', undefined);
    });
async function $0d4b4afaa84d28bb$export$3273ac3481dc0616(cloudId = '', baseUrl = '') {
    const response = await $0d4b4afaa84d28bb$export$194985100c06d296($0d4b4afaa84d28bb$var$productRecommendationsUrl(baseUrl), {
        method: 'get'
    });
    const sitesResponse = $0d4b4afaa84d28bb$var$convertProductRecommendationsResponseToJoinableSitesResponse(response);
    if (!cloudId) return sitesResponse;
    const filteredSites = sitesResponse?.sites?.filter((site)=>site.cloudId === cloudId);
    // This mapping is required for calling the get-eligible-collaborators endpoint
    const flattenedProducts = filteredSites?.flatMap((site)=>Object.keys(site.products || []).map((productName)=>$0d4b4afaa84d28bb$var$tenantedProductsToProduct[productName]));
    if (!filteredSites || filteredSites?.length === 0 || flattenedProducts?.length === 0) return {
        sites: filteredSites
    };
    const collaboratorsResponse = await fetch($0d4b4afaa84d28bb$var$collaboratorsUrl, {
        method: 'POST',
        body: JSON.stringify({
            products: flattenedProducts,
            cloudId: cloudId
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!collaboratorsResponse.ok) return {
        sites: filteredSites
    };
    const collaboratorsJson = await collaboratorsResponse.json();
    // Renames key with tenantedProducts and filters out empty responses
    const updatedProductCollaborators = Object.fromEntries(Object.entries(collaboratorsJson).filter((item)=>Array.isArray(item[1]) && item[1]?.length !== 0).map((item)=>{
        return [
            $0d4b4afaa84d28bb$var$supportedTenantedProducts[item[0]] || item[0],
            item[1].map(({ userProfile: userProfile })=>({
                    displayName: userProfile?.name || '',
                    avatarUrl: userProfile?.picture || ''
                }))
        ];
    }));
    const updatedProductCollaboratorsKeys = Object.keys(updatedProductCollaborators);
    // Inject collaborators with each related product
    // Inject users with each site.
    const sitesWithCollaborators = filteredSites.map((site)=>{
        updatedProductCollaboratorsKeys.forEach((collaboratorProductKey)=>{
            if (site?.products?.[collaboratorProductKey]) site.products[collaboratorProductKey].collaborators = updatedProductCollaborators[collaboratorProductKey];
        });
        site.users = Object.keys(site?.products || {}).reduce((users, product)=>{
            users[product] = updatedProductCollaborators[product] || [];
            return users;
        }, {});
        return site;
    });
    const updatedSiteResponse = {
        sites: sitesWithCollaborators
    };
    return updatedSiteResponse;
}
const $0d4b4afaa84d28bb$export$30ea0038b891f1cf = (baseUrl)=>({ cloudId: cloudId })=>$0d4b4afaa84d28bb$export$3273ac3481dc0616(cloudId, baseUrl);

});

parcelRegister("1Y265", function(module, exports) {

$parcel$export(module.exports, "customShowFlag", () => $9486f2e1dfc1398c$export$90897e206b3c86f5);
const $9486f2e1dfc1398c$var$appearanceMappedToConfluenceFlagType = (appearance)=>{
    switch(appearance){
        case 'normal':
        case 'success':
            return 'success-circle';
        default:
            return appearance;
    }
};
const $9486f2e1dfc1398c$export$90897e206b3c86f5 = (flags)=>(flag)=>{
        const { title: title, description: description, appearance: appearance, actions: actions } = flag;
        flags.showFlag({
            type: $9486f2e1dfc1398c$var$appearanceMappedToConfluenceFlagType(appearance),
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };

});


//# sourceMappingURL=AppSwitcherContent.233f0313.js.map
